import Module from './Module';
import { Draggable } from 'react-beautiful-dnd';
import React from 'react';

export default class DraggableModule extends React.Component {
  render() {
    const { module, moveIcon, index, height, inactive, selected } = this.props;
    return (
      <Draggable
        draggableId={module.uid.toString()}
        index={index}
        isDragDisabled={inactive}
      >
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              ...provided.draggableProps.style,
              height:
                snapshot.isDragging && height.length === 2
                  ? height[0]
                  : height[1],
            }}
          >
            <Module
              module={module}
              moveIcon={moveIcon}
              inactive={inactive}
              selected={selected}
            />
          </div>
        )}
      </Draggable>
    );
  }
}
